var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCashWalletFreezeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    d: "M8.5 0C13.1944 0 17 3.80558 17 8.5C17 13.1944 13.1944 17 8.5 17C3.80558 17 0 13.1944 0 8.5C0 3.80558 3.80558 0 8.5 0ZM8.5 8C8.22386 8 8 8.22386 8 8.5V11.7002C8.00011 11.9762 8.22392 12.2002 8.5 12.2002C8.77608 12.2002 8.99989 11.9762 9 11.7002V8.5C9 8.22386 8.77614 8 8.5 8ZM8.5 4.7998C8.22392 4.7998 8.0001 5.02375 8 5.2998C8 5.57595 8.22386 5.7998 8.5 5.7998H8.50977C8.78591 5.7998 9.00977 5.57595 9.00977 5.2998C9.00967 5.02375 8.78585 4.7998 8.50977 4.7998H8.5Z",
    fill: "#DD8605"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashWalletFreezeIcon);
export default __webpack_public_path__ + "static/media/cash-wallet-freeze-icon.0501e7e3bd4a6eef1446db6d88807f13.svg";
export { ForwardRef as ReactComponent };